import LeadReportActionTypes from './lead-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	getLeadListResponse: null,
	getLeadListArr: [],
	getOfficerListResponse: null,
	getOfficerListArr: [],
};

const leadReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case LeadReportActionTypes.FETCH_LEAD_LIST_SUCCESS:
			return {
				...state,
				getLeadListArr: docodeHexResponse(action.payload, 'GetLeadDetailsListKey'),
				getLeadListResponse: action.payload,
			};

		case LeadReportActionTypes.FETCH_LEAD_LIST_FAILURE:
			return { ...state, getLeadListResponse: action.payload };

		case LeadReportActionTypes.FETCH_LEAD_LIST_CHANGED:
			return { ...state, getLeadListResponse: null };

		case LeadReportActionTypes.FETCH_OFFICER_LIST_SUCCESS:
			return {
				...state,
				getOfficerListArr: docodeHexResponse(action.payload, 'GetOfficerDetailsListKey'),
				getOfficerListResponse: action.payload,
			};

		case LeadReportActionTypes.FETCH_OFFICER_LIST_FAILURE:
			return { ...state, getOfficerListResponse: action.payload };

		case LeadReportActionTypes.FETCH_OFFICER_LIST_CHANGED:
			return { ...state, getOfficerListResponse: null };

		case LeadReportActionTypes.FETCH_LEAD_CARD_EXCEL_SUCCESS:
			return {
				...state,
				fetchLoanCardExcelStatus: 'SUCCESS',
			};

		case LeadReportActionTypes.FETCH_LEAD_CARD_EXCEL_FAILURE:
			return { ...state, fetchLoanCardExcelStatus: 'FAILURE' };

		case LeadReportActionTypes.FETCH_LEAD_CARD_EXCEL_CHANGED:
			return { ...state, fetchLoanCardExcelStatus: null };

		default:
			return state;
	}
};
export default leadReducer;
